
import { Options, Vue } from "vue-class-component";
import { AuthController } from "@/app/ui/controllers/AuthController";
import Footer from "@/app/ui/components/footer/index.vue";
import { defineAsyncComponent } from "@vue/runtime-core";
import { AccountController } from "../../controllers/AccountController";
import {
  maxLengthPhoneNumber,
  validateInputEmail,
  validatePhoneNumber
} from "@/app/infrastructures/misc/Utils";
import ReCaptcha from "./component/recaptcha.vue";
const ModalOtherMethod = defineAsyncComponent(() =>
  import("./component/modal-method-verification.vue")
);
import OTP from "./component/otp.vue";
import SelectPhoneCountry from "../shipment/booking/component/select-phone-country.vue";
import convertPhoneNumberV2 from "@/app/infrastructures/misc/common-library/ConvertPhoneNumberV2";

@Options({
  components: {
    Footer,
    ModalOtherMethod,
    OTP,
    ReCaptcha,
    SelectPhoneCountry
  },
  watch: {
    "$route.name"() {
      this.onResetReCaptcha();
      this.handleError();
      this.form.email = "";
      if (this.scriptEl) this.scriptEl.remove();
      delete (window as any).__recaptchaLoaded;
    }
  }
})
export default class ForgotEmail extends Vue {
  captchaToken = "";
  grecaptcha: any = null;
  widgetId: any = null;
  scriptEl: any = null;

  mounted() {
    this.initPage();
    this.initTypeForm();
  }

  unmounted() {
    this.onResetReCaptcha();
  }

  initPage() {
    if (
      (!this.emailOrUsername || !this.dataProfile.account_type) &&
      !this.isVerificationOTPPage
    ) {
      this.$router.replace("/");
    }
    AuthController.setError(false);
  }

  get isVerificationOTPPage() {
    return this.$route.path === "/account/verification-otp";
  }

  get typeFormValue() {
    if (this.isInternal) return "email_account";
    else if (this.isClient) return "client_code";
    return "partner_code";
  }
  form = {
    email: ""
  };
  typeForm = {
    caption: "",
    form: "",
    type: this.isInternal ? "email" : "text",
    placeholder: "",
    value: this.typeFormValue,
    phoneCode: "+62"
  };
  showError = {
    form: false
  };
  isOpen = false;
  showModalOtherMethod = false;

  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }

  get isInternal() {
    const accountType = ["internal", "customer-service"];
    return accountType.includes(this.dataProfile.account_type);
  }

  get isClient() {
    return this.dataProfile.account_type === "client";
  }

  get methodsPartnerClient() {
    return [
      {
        title: this.$t("verificationAccount.methods.partnerClientCode"),
        value: this.isClient ? "client_code" : "partner_code",
        caption: this.$t("verificationAccount.methods.partnerClientCode"),
        type: "text",
        placeholder: this.$t("verificationAccount.placeholders.partnerClientCode")
      },
      {
        title: this.$t("verificationAccount.methods.partnerClientId"),
        value: this.isClient ? "client_id" : "partner_id",
        caption: this.$t("verificationAccount.methods.partnerClientId"),
        type: "number",
        placeholder: this.$t("verificationAccount.placeholders.partnerClientId")
      },
      {
        title: this.$t("verificationAccount.methods.userEmail"),
        value: "email_account",
        caption: this.$t("verificationAccount.email"),
        type: "email",
        placeholder: this.$t("verificationAccount.placeholders.email")
      },
      {
        title: this.$t("verificationAccount.methods.userPhone"),
        value: "phone_number_account",
        caption: this.$t("verificationAccount.phoneNumber"),
        type: "text",
        placeholder: this.$t("verificationAccount.placeholders.yourPhoneNumber")
      },
      {
        title: this.$t("verificationAccount.methods.partnerClientEmail"),
        value: this.isClient ? "email_client" : "email_partner",
        caption: this.$t("verificationAccount.captions.partnerClientEmail"),
        type: "email",
        placeholder: this.$t("verificationAccount.placeholders.email")
      },
      {
        title: this.$t("verificationAccount.methods.partnerClientPhone"),
        value: this.isClient ? "phone_number_client" : "phone_number_partner",
        caption: this.$t("verificationAccount.captions.partnerClientPhone"),
        type: "text",
        placeholder: this.$t("verificationAccount.placeholders.yourPhoneNumber")
      }
    ];
  }

  initTypeForm() {
    this.typeForm.caption = this.isInternal
      ? this.$t("verificationAccount.email")
      : this.$t("verificationAccount.methods.partnerClientCode");
    this.typeForm.placeholder = this.isInternal
      ? this.$t("verificationAccount.placeholders.email")
      : this.$t("verificationAccount.placeholders.partnerClientCode");
  }

  errorFormEmail(str: string) {
    return !validateInputEmail(str);
  }

  maxLengthPhoneNumber(phone: string) {
    return maxLengthPhoneNumber(phone);
  }

  validatePhoneNumber(str: string) {
    return validatePhoneNumber(str);
  }

  convertPhoneNumber(val: string) {
    return convertPhoneNumberV2(val);
  }

  formatNumber(value: string) {
    return value.replace(/\D+|\+/g, "");
  }

  //Error Internet or System
  get isErrorInternetOrSystem() {
    return AuthController.isErrorInternetOrSystem;
  }
  //Error Cause
  get errorCause() {
    return AuthController.errorCause;
  }

  handleErrorClose() {
    AuthController.handleError();
  }

  handleError() {
    AuthController.setError(false);
    AuthController.setVerificationAcountErrorMessage("");
  }

  get captionError() {
    return AuthController.verificationAcountErrorMessage;
  }

  get isError() {
    return AuthController.isError;
  }

  get errorPhoneNumber() {
    return {
      error: this.isError,
      message: this.captionError
    }
  }

  get emailOrUsername() {
    return this.dataProfile.email;
  }

  get isLoading() {
    return AuthController.isLoading;
  }

  submitVerification() {
    AuthController.verificationAccount({
      emailOrUsername: this.emailOrUsername,
      question: this.typeForm.value,
      answer: this.typeForm.value.includes("phone")
        ? this.convertPhoneNumber(this.typeForm.phoneCode+this.typeForm.form)
        : this.typeForm.form,
      captchaToken: this.captchaToken
    }).catch(() => {
      this.grecaptcha.reset();
      this.captchaToken = "";
    });
  }

  closeModalOtherMethod() {
    this.showModalOtherMethod = !this.showModalOtherMethod;
  }

  onClickMethodVerification(key: any) {
    this.closeModalOtherMethod();
    this.typeForm.form = "";
    this.typeForm.caption = key.title;
    this.typeForm.type = key.type;
    this.typeForm.placeholder = key.placeholder;
    this.typeForm.value = key.value;
    this.handleError();
  }

  onClickMethodInternal() {
    this.typeForm.form = "";
    this.typeForm.caption = this.typeForm.value.includes("phone")
      ? this.$t("verificationAccount.email")
      : this.$t("verificationAccount.phoneNumber");
    this.typeForm.type = this.typeForm.value.includes("phone")
      ? "email"
      : "text";
    this.typeForm.placeholder = this.typeForm.value.includes("phone")
      ? this.$t("verificationAccount.placeholders.email")
      : this.$t("verificationAccount.placeholders.yourPhoneNumber");
    this.typeForm.value = this.typeForm.value.includes("phone")
      ? "email_account"
      : "phone_number_account";
    this.handleError();
  }

  onSuccessReCaptcha(value: string) {
    this.captchaToken = value;
  }

  onResetReCaptcha() {
    this.captchaToken = "";
  }

  onGetGrecaptcha(response: any) {
    this.widgetId = response.widgetId;
    this.grecaptcha = response.grecaptcha;
    this.scriptEl = response.scriptEl;
  }

  setPhoneNumber(val: string) {
    this.typeForm.form = val;
  }

  setPhoneCodeNumber(val: string) {
    this.typeForm.phoneCode = val;
  }
}
